<template>
  <div class="skill-box" :class="{ 'small-skill-box': size == 'small', 'is-edit': mode === 'edit' }">
    <div class="skill-icon" v-if="data.isShowIcon">
      <resize-box
        :width="data.iconSize ? data.iconSize.width : defaultIconSize.width"
        :height="data.iconSize ? data.iconSize.height : defaultIconSize.height"
        :active="mode == 'edit' ? ['r', 'rb', 'b'] : []"
        @resize:end="handleResizeEnd"
      >
        <img v-if="data.icon" :src="data.icon" />
        <upload-image v-else-if="mode === 'edit'" @onImageUploaded="handelIconUploaded">
          <div class="upload-box">
            <div class="upload-icon">
              <i class="iconfont icon-tianjia"></i>
            </div>
          </div>
        </upload-image>
        <div class="edit-btns" v-if="data.icon && mode === 'edit'">
          <button class="btn edit-btn">
            <upload-image type="edit" :data="data.icon" @onImageUploaded="handelIconUploaded">
              <i class="wiki-icon wiki-editable-edit"></i>
            </upload-image>
          </button>
        </div>
      </resize-box>
    </div>
    <div class="skill-main" v-if="data.isShowName || data.isShowDesc || data.isShowMore">
      <div class="skill-name" v-if="data.isShowName">
        <span class="name">
          <text-box
            type="editor"
            position="rightTop"
            :mode="mode"
            :image-style="{ height: '36px' }"
            :value="data.name || '技能名称'"
            @onChange="handleNameChange"
          >
            {{ data.name || "技能名称" }}
          </text-box>
        </span>
      </div>
      <div class="skill-desc" v-if="data.isShowDesc">
        <text-box
          type="editor"
          position="rightTop"
          :includeBtns="['confirm', 'edit']"
          :mode="mode"
          :image-style="{ height: '36px' }"
          :value="data.desc"
          @onChange="handleDescChange"
        >
          {{ data.desc || "技能描述" }}
        </text-box>
      </div>
      <div class="skill-more" v-if="data.isShowMore">
        <div class="more-btn" @click="handleOpenMore">
          <span class="icon wiki-module-up"></span>
          <span class="name">{{ data.moreBtn || "查看升级效果" }}</span>
        </div>
      </div>
      <el-dialog
        v-if="visibleMoreDialog"
        :visible.sync="visibleMoreDialog"
        append-to-body
        width="600px"
        :before-close="handleMoreDialogClose"
        custom-class="skill-more-dialog"
      >
        <div class="skill-more-container">
          <text-box
            type="editor"
            :includeBtns="[['markEditorNumberColor'], 'confirm', 'edit']"
            :mode="mode"
            :image-style="{ height: '50px' }"
            :value="data.moreInfo"
            @onChange="handleMoreInfoChange"
          >
            {{ data.moreInfo || "无内容" }}
          </text-box>
        </div>
      </el-dialog>
    </div>

    <div class="edit-btns-wrapper" v-if="mode == 'edit'">
      <edit-btns
        :editBtns="size == 'small' ? ['setup'] : ['drag', 'setup', 'delete', 'add']"
        @onSetup="handleOpenListItemSetup"
        @onDelete="handleListItemDelete"
        @onAdd="handleAddListInfo"
      ></edit-btns>
    </div>

    <setup-panel
      v-if="mode === 'edit'"
      ref="setupPanel"
      :data="data"
      :isShowTabs="isShowTabs"
      :tabs="tabs"
      @onChange="handleListItemSetup"
    ></setup-panel>
  </div>
</template>

<script>
// components
import UploadImage from "../../../../components/UploadImage";
import TextBox from "../../../../components/TextBox";
import ResizeBox from "../../../../components/ResizeBox";
import SetupPanel from "./SetupPanel.vue";
import EditBtns from "../../../../components/EditBtns";

export default {
  name: "SkillInfo",
  components: {
    UploadImage,
    TextBox,
    ResizeBox,
    SetupPanel,
    EditBtns
  },
  props: {
    mode: String,
    size: {
      type: String,
      default: "default"
    },
    data: {
      type: Object,
      default: () => ({})
    },
    isShowTabs: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      iconSize: this.data.iconSize || {
        width: 48,
        height: 48
      },
      uploadImageHref: this.data.icon || "",
      inputNameValue: this.data.name || "",
      inputLabelValue: this.data.label || "",
      inputDescValue: this.data.desc || "",
      inputMoreValue: this.data.moreInfo || "",
      visibleMoreDialog: false
    };
  },
  computed: {
    defaultIconSize() {
      return this.size != "small"
        ? {
            width: 60,
            height: 60
          }
        : {
            width: 48,
            height: 48
          };
    },
    isEditorValue() {
      return (
        this.data && typeof this.data.desc !== "string" && this.data.desc.type && this.data.desc.type === "simpleEditor"
      );
    }
  },

  mounted() {},

  methods: {
    // icon resize
    handleResizeEnd({ width, height }) {
      this.iconSize = {
        width: width || this.defaultIconSize.width,
        height: height || this.defaultIconSize.height
      };
      this.hanldeConfirm();
    },
    // icon上传
    handelIconUploaded(imgList) {
      this.uploadImageHref = imgList[0];
      this.hanldeConfirm();
    },
    // 名称change
    handleNameChange(name) {
      this.inputNameValue = name;
      this.hanldeConfirm();
    },
    // 描述change
    handleDescChange(desc) {
      this.inputDescValue = desc;
      this.hanldeConfirm();
    },
    // 确认提交
    hanldeConfirm() {
      this.$emit("onChange", {
        ...this.data,
        iconSize: this.iconSize,
        icon: this.uploadImageHref,
        name: this.inputNameValue,
        label: this.inputLabelValue,
        desc: this.inputDescValue,
        moreInfo: this.inputMoreValue
      });
    },
    // 升级效果
    handleMoreInfoChange(moreInfo) {
      this.inputMoreValue = moreInfo;
      this.hanldeConfirm();
    },
    // 打开更多
    handleOpenMore() {
      this.visibleMoreDialog = true;
    },
    // 关闭更多
    handleMoreDialogClose() {
      this.visibleMoreDialog = false;
      this.hanldeConfirm();
    },
    // item 打开设置
    handleOpenListItemSetup() {
      this.$refs.setupPanel.open();
    },
    // item 设置
    handleListItemSetup(data) {
      this.$emit("onChange", data);
    },
    // item 删除
    handleListItemDelete() {
      this.$emit("onDelete");
    },
    // item 添加
    handleAddListInfo() {
      this.$emit("onAdd");
    }
  }
};
</script>

<style lang="less" scoped>
.is-edit {
  &:hover {
    outline: #c7ccd5;
    outline-style: solid;
    outline-width: 3px;
    .edit-btns-wrapper {
      display: inline-flex;
    }
  }

  .skill-icon {
    /deep/ .resizable-component {
      &:hover {
        background-color: #c7ccd5;
        outline: #c7ccd5;
        outline-style: solid;
        outline-width: 3px;
        cursor: pointer;
        .edit-btns {
          display: inline-flex;
        }
      }
    }
  }
}
.edit-btns-wrapper {
  display: none;
  position: absolute;
  box-sizing: content-box;
  height: 20px;
  right: 0;
  top: -23px;
  padding-bottom: 3px;
}
.skill-box {
  position: relative;
  width: 100%;
  display: flex;
  min-height: 22px;

  .skill-icon {
    position: relative;
    display: inline-block;
    margin-right: 26px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .edit-btns {
      display: none;
      position: absolute;
      height: 20px;
      right: 0px;
      top: -20px;
      .btn {
        width: 20px;
        height: 20px;
        color: #ffffff;
        border-radius: 4px;
        margin-left: 3px;
        border: none;
        vertical-align: middle;
        line-height: 20px;
        text-align: center;
        overflow: hidden;
        &:hover {
          opacity: 0.9;
        }
        .wiki-icon {
          display: inline-block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .skill-main {
    flex: 1;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.11);
    padding-bottom: 12px;
    .skill-name {
      width: 100%;
      margin-bottom: 6px;
      .name {
        display: inline-block;
        vertical-align: bottom;
        min-width: 60px;
        min-height: 30px;
        font-size: 20px;
        font-weight: bold;
        color: #212121;
        line-height: 22px;
        padding: 4px 0;
        margin-right: 6px;
      }
      .label {
        min-width: 50px;
        font-size: 14px;
        font-weight: bold;
        color: #707478;
        line-height: 24px;
        display: inline-block;
        vertical-align: bottom;
      }
    }
    .skill-desc {
      width: 100%;
      font-size: 14px;
      font-weight: 400;
      color: #373737;
      line-height: 22px;
    }
    .skill-more {
      width: 100%;
      padding-top: 10px;

      .more-btn {
        display: inline-block;
        font-size: 14px;
        font-weight: 400;
        color: #212121;
        line-height: 22px;
        cursor: pointer;
        .icon {
          display: inline-block;
          width: 16px;
          height: 16px;
          border-radius: 4px;
          margin-right: 9px;
          vertical-align: middle;
        }
        .name {
          vertical-align: middle;
        }
      }
    }
  }
}

.upload-box {
  width: 100%;
  height: 100%;
  background: #727c86;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: inherit;

  .upload-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
    text-align: center;
    line-height: 32px;
    font-size: 18px;
    color: #fff;
  }
}

.small-skill-box {
  .skill-icon {
    display: inline-block;
    margin-right: 12px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .skill-main {
    border-bottom: none;
    .skill-name {
      margin-bottom: 7px;
      .name {
        display: inline-block;
        vertical-align: bottom;
        min-width: 120px;
        min-height: 28px;
        font-size: 20px;
        font-weight: bold;
        color: #212121;
        line-height: 28px;
        margin-right: 10px;
      }
      .label {
        min-width: 50px;
        font-size: 14px;
        font-weight: bold;
        color: #707478;
        line-height: 22px;
        display: inline-block;
        vertical-align: bottom;
      }
    }
  }
}

/deep/ .skill-more-dialog {
  background: #e9f0f7;
  .el-dialog__header {
    padding: 0;
    height: 0;
    .el-dialog__headerbtn {
      top: 6px;
      right: 6px;
    }
  }
}
.skill-more-container {
  background: #e9f0f7;
  margin: 20px 0;
}
</style>
